import type { ReactNode } from "react";

import { Inline } from "@/design-system/Inline";

interface CollectionControlsProps {
  summary?: ReactNode;
  options?: ReactNode;
  action?: ReactNode;
}

/** Result summary, collection options, and a trailing ticket-collection action. */
export function CollectionControls({ action, options, summary }: CollectionControlsProps): ReactNode {
  return (
    <Inline gap="md" align="center" justify="between">
      {summary}
      {options && <div className="flex flex-wrap items-center gap-space-md @xs:ml-auto">{options}</div>}
      {action}
    </Inline>
  );
}
